/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The state of a transaction.
 */
export const TransactionState = /* #__PURE__ */ parsers.exactly('pending', 'success', 'refunding', 'refunded', 'failed');
